// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MuiChip-label{font-size:14px;font-weight:bold}", "",{"version":3,"sources":["webpack://src/styles/sass/video-gallery.scss"],"names":[],"mappings":"AAAA,eACC,cAAA,CACA,gBAAA","sourcesContent":[".MuiChip-label {\r\n\tfont-size: 14px;\r\n\tfont-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
